export default {
  layers: 'Layers',
  panzoom: {
    helpText: 'Useful shortcuts:\n'
      + 'Ctrl + mouse wheel - zoom in/out\n'
      + 'Left mouse click + drag - pan the area',
  },
  errors: {
    pointsRequired: 'The points must be added',
  },
};
